class HeaderDelegate {
    setUser(user) {
        this.setState({ user: user || {} });
    }

    setDropdownOpen(isOpen) {
        this.setState({ dropdownOpen: isOpen });
    }

    setDrawerOpen(isOpen) {
        this.setState({ drawerOpen: isOpen });
    }

    setActiveItem(itemKey) {
        this.setState({ activeItem: itemKey });
    }
}

export default HeaderDelegate;
